import { useState, useEffect } from 'react';
import { faqs } from '@/mocks/faqs';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  useEffect(() => {
    const existing = document.querySelector('script[data-faq-schema]');
    if (existing) existing.remove();

    const schema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faqs.map((faq) => ({
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: faq.answer,
        },
      })),
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-faq-schema', 'true');
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const el = document.querySelector('script[data-faq-schema]');
      if (el) el.remove();
    };
  }, []);

  return (
    <section className="px-4 md:px-6 py-10 md:py-14">
      <div className="text-center mb-8">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
          常见问题
        </h2>
        <p className="text-sm text-foreground-500 mt-1">关于哈哈影院的常见疑问解答</p>
      </div>
      <div className="max-w-2xl mx-auto space-y-3">
        {faqs.map((faq, i) => (
          <div
            key={i}
            className="rounded-lg border border-background-200 bg-background-50 overflow-hidden"
          >
            <button
              onClick={() => setOpenIndex(openIndex === i ? null : i)}
              className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
            >
              <h4 className="font-heading font-medium text-foreground-900 text-sm pr-4">
                {faq.question}
              </h4>
              <i
                className={`ri-arrow-down-s-line text-foreground-500 transition-transform duration-200 w-5 h-5 flex items-center justify-center flex-shrink-0 ${
                  openIndex === i ? 'rotate-180' : ''
                }`}
              ></i>
            </button>
            {openIndex === i && (
              <div className="px-5 pb-4">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}